import { ModuleFE_BaseSandboxModule } from '../ModuleFE_BaseSandboxModule.js';
import axios from 'axios';
import { ModuleFE_AdvisorWindowMessenger } from '../../../../modules/ModuleFE_AdvisorWindowMessenger/index.js';
export class Module_SandboxOrders_Class extends ModuleFE_BaseSandboxModule {
    constructor() {
        super('storage-orders', []);
    }
    getHistory() {
        return ModuleFE_AdvisorWindowMessenger.getHistory();
    }
    async listTemplates() {
        if (this.config.templatesFirebaseRTDB) {
            let templates;
            try {
                templates = (await axios.get(this.config.templatesFirebaseRTDB)).data;
            }
            catch (e) {
                this.logError(`Failed to fetch templates from Firebase RTDB: ${this.config.templatesFirebaseRTDB}`, e);
                templates = [];
            }
            if (Array.isArray(templates))
                return templates;
        }
        return [];
    }
    clearHistory() {
        ModuleFE_AdvisorWindowMessenger.clearHistory();
    }
    sendRequestToEpicWindow(content) {
        ModuleFE_AdvisorWindowMessenger.sendMessage(content);
    }
}
export const ModuleFE_SandboxOrders = new Module_SandboxOrders_Class();
//# sourceMappingURL=ModuleFE_SandboxOrders.js.map